module.exports = __webpack_public_path__ + "img/khzs.61b0919c.png";